import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ConstantsService } from 'src/app/services/constants.service';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent implements OnInit {

  constructor(private constants: ConstantsService,
    private route: Router
    ) { }

  ngOnInit(): void {
  }

  navigateToHomePage() {
    this.route.navigate([this.constants.homeUrl])
  }


}
